export default __webpack_public_path__ + "static/noInstallation-6c7080196c48303ce2fbd532ba7720fa.png";